import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { onCLS, onINP, onLCP } from "web-vitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Core Web Vitals reporting (CLS, INP, LCP)
const reportVital = ({ name, value, rating }) => {
  if (process.env.NODE_ENV === "development") console.log(`[Web Vital] ${name}: ${Math.round(value)} (${rating})`);
};
onCLS(reportVital);
onINP(reportVital);
onLCP(reportVital);
